var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWrk10(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 302,
    height: 115,
    viewBox: "0 0 302 115",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1132",
    "data-name": "Rectangle 1132",
    width: 176.395,
    height: 59.222,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1101",
    "data-name": "Rectangle 1101",
    width: 46.096,
    height: 39.538,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1102",
    "data-name": "Rectangle 1102",
    width: 15.746,
    height: 25.946,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1103",
    "data-name": "Rectangle 1103",
    width: 14.123,
    height: 20.655,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1104",
    "data-name": "Rectangle 1104",
    width: 14.946,
    height: 20.655,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1105",
    "data-name": "Rectangle 1105",
    width: 12.592,
    height: 20.655,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1106",
    "data-name": "Rectangle 1106",
    width: 14.713,
    height: 21.245,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1107",
    "data-name": "Rectangle 1107",
    width: 14.762,
    height: 20.655,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-10"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1108",
    "data-name": "Rectangle 1108",
    width: 17.329,
    height: 21.245,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-11"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1109",
    "data-name": "Rectangle 1109",
    width: 16.626,
    height: 20.655,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-12"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1110",
    "data-name": "Rectangle 1110",
    width: 20.257,
    height: 23.12,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-13"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1111",
    "data-name": "Rectangle 1111",
    width: 3.564,
    height: 3.47,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-14"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1113",
    "data-name": "Rectangle 1113",
    width: 6.917,
    height: 2.977,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-16"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1116",
    "data-name": "Rectangle 1116",
    width: 10.058,
    height: 14.376,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-17"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1117",
    "data-name": "Rectangle 1117",
    width: 3.564,
    height: 3.471,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-21"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1123",
    "data-name": "Rectangle 1123",
    width: 23.027,
    height: 14.376,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-22"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1124",
    "data-name": "Rectangle 1124",
    width: 10.746,
    height: 23.035,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-26"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1130",
    "data-name": "Rectangle 1130",
    width: 5.205,
    height: 14.376,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-27"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11061",
    "data-name": "Path 11061",
    d: "M104.893,0c-1.338,0-1.338,0-1.216,1.347a14.265,14.265,0,0,0,14.015,13q5.987.03,11.973-.018a6.253,6.253,0,0,1,3.393.884,5.365,5.365,0,0,1-3.244,9.858q-5.056,0-10.111.008-7.494.008-14.988,0c-.823,0-1.1.213-1.06,1.062.066,1.448.04,2.9-.008,4.352-.019.6.122.872.757.982a22.332,22.332,0,0,1,13.183,7.39,1.511,1.511,0,0,0,1.264.564c1.947-.016,3.893-.015,5.84-.015q1.07,0,2.142,0c.6,0,1.2.02,1.8.04a22.969,22.969,0,0,0,3.965-.094,19.5,19.5,0,0,0,10.368-4.811,20.088,20.088,0,0,0,5.575-8.319,19.614,19.614,0,0,0-8.907-23.648A20.078,20.078,0,0,0,129.882.016c-3.92.034-7.838.009-11.758.009V0Z",
    transform: "translate(-103.627)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -2.038,
    y1: 1.139,
    x2: -2.017,
    y2: 1.139,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#009b82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.122,
    stopColor: "#009684"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.254,
    stopColor: "#00898d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.389,
    stopColor: "#00749c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#005dac"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.633,
    stopColor: "#005291"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#004066"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.999,
    stopColor: "#003a56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003a56"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-28"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11062",
    "data-name": "Path 11062",
    d: "M103.71,27.18a14.51,14.51,0,0,1,.412,5.371,55.6,55.6,0,0,0-.1,11.937,9.167,9.167,0,0,0,8.655,7.755,19.271,19.271,0,0,1-2.211-6.151c-.635-4-.842-8.041-1.4-12.048a23.622,23.622,0,0,1,1.576,5.11c.544,2.473.684,5.026,1.416,7.468a10.9,10.9,0,0,0,3.181,5.409c.4.341.658.4.96-.086.491-.793,1.091-1.523,1.512-2.35,2.543-4.994,2-9.9-.659-14.634a17.206,17.206,0,0,0-5.647-5.776,17.9,17.9,0,0,0-7.024-2.768,2.036,2.036,0,0,0-.346-.035c-.44,0-.478.257-.323.8",
    transform: "translate(-103.627 -26.382)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -4.004,
    y1: 0.956,
    x2: -3.963,
    y2: 0.956,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#009b82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.122,
    stopColor: "#009684"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.254,
    stopColor: "#00898d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.389,
    stopColor: "#00749c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#005dac"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.609,
    stopColor: "#005ba8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.716,
    stopColor: "#00569c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.822,
    stopColor: "#004e88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.927,
    stopColor: "#00436d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.999,
    stopColor: "#003a56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003a56"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-29"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1445",
    "data-name": "Rectangle 1445",
    width: 176.615,
    height: 59.564,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "wrk-10",
    transform: "translate(-1478 -3678)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_894",
    "data-name": "Rectangle 894",
    width: 302,
    height: 115,
    transform: "translate(1478 3678)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Component_25_7",
    "data-name": "Component 25 \\u2013 7",
    transform: "translate(1540.78 3705.855)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2783",
    "data-name": "Group 2783",
    transform: "translate(0.22 0.145)",
    opacity: 0
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2782",
    "data-name": "Group 2782",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2781",
    "data-name": "Group 2781",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2780",
    "data-name": "Group 2780",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2710",
    "data-name": "Group 2710",
    transform: "translate(130.298 0)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2709",
    "data-name": "Group 2709",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2708",
    "data-name": "Group 2708",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10685",
    "data-name": "Path 10685",
    d: "M110.3.025c3.923,0,7.846.027,11.77-.008a20.091,20.091,0,0,1,9.763,2.571,19.633,19.633,0,0,1,8.916,23.672,20.094,20.094,0,0,1-5.581,8.328A19.506,19.506,0,0,1,124.786,39.4a41.632,41.632,0,0,1-5.77.054c-2.664,0-5.327-.008-7.991.016a1.511,1.511,0,0,1-1.265-.565,22.361,22.361,0,0,0-13.2-7.4c-.634-.11-.777-.38-.756-.982.046-1.451.071-2.907.007-4.357-.037-.849.237-1.065,1.061-1.064,8.374.02,16.75-.01,25.125-.005a5.371,5.371,0,0,0,3.247-9.869,6.252,6.252,0,0,0-3.4-.886q-5.993.049-11.986.018A14.278,14.278,0,0,1,95.835,1.35C95.713,0,95.713,0,97.051,0q6.623,0,13.245,0V.025",
    transform: "translate(-95.785 0)",
    fill: "#040504"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2713",
    "data-name": "Group 2713",
    transform: "translate(130.298 33.275)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2712",
    "data-name": "Group 2712"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2711",
    "data-name": "Group 2711",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10686",
    "data-name": "Path 10686",
    d: "M101.226,32.131c.558,4.013.764,8.061,1.4,12.062a19.276,19.276,0,0,0,2.213,6.157,9.178,9.178,0,0,1-8.664-7.763,55.7,55.7,0,0,1,.1-11.949,14.533,14.533,0,0,0-.411-5.377c-.189-.658-.092-.9.668-.763a17.938,17.938,0,0,1,7.033,2.771,17.2,17.2,0,0,1,5.652,5.783c2.664,4.738,3.2,9.649.66,14.649-.42.827-1.022,1.559-1.513,2.352-.3.491-.565.429-.962.087a10.928,10.928,0,0,1-3.186-5.417c-.732-2.443-.871-5-1.416-7.475a23.7,23.7,0,0,0-1.578-5.116",
    transform: "translate(-95.785 -24.461)",
    fill: "#040504"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2716",
    "data-name": "Group 2716",
    transform: "translate(0 0.295)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2715",
    "data-name": "Group 2715"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2714",
    "data-name": "Group 2714",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10687",
    "data-name": "Path 10687",
    d: "M13.809,8.812c-.849,2.632-3.208,4.4-7.636,4.4H4.3a.487.487,0,0,0-.484.49v6.682a.487.487,0,0,1-.484.49H.483A.486.486,0,0,1,0,20.382V.705A.486.486,0,0,1,.483.217H7.448a6.647,6.647,0,0,1,6.361,8.595M3.82,3.859v5.8a.486.486,0,0,0,.484.488H6.021c3.269,0,4.186-1.385,4.186-3.389,0-2.386-1.283-3.389-4-3.389H4.3a.487.487,0,0,0-.484.49",
    transform: "translate(0 -0.216)",
    fill: "#040504"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2719",
    "data-name": "Group 2719",
    transform: "translate(17.847 0.295)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2718",
    "data-name": "Group 2718"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2717",
    "data-name": "Group 2717",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10688",
    "data-name": "Path 10688",
    d: "M19.475.217c4.647,0,7.335,1.709,7.335,5.981,0,3.506-2.107,5.3-4.646,5.686V12c1.039.471,1.743,1.208,2.752,2.888L28,20.134a.488.488,0,0,1-.416.739H24.162a.482.482,0,0,1-.422-.252l-3.531-6.437a2.527,2.527,0,0,0-2.476-1.326h-.34a.485.485,0,0,0-.483.488v7.037a.487.487,0,0,1-.486.49H13.6a.486.486,0,0,1-.484-.49V.705A.485.485,0,0,1,13.6.217ZM16.91,9.362a.485.485,0,0,0,.483.49H19.05c2.657,0,3.88-1.061,3.88-3.33S21.523,3.31,19.017,3.31H17.393a.485.485,0,0,0-.483.488Z",
    transform: "translate(-13.119 -0.216)",
    fill: "#040504"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2722",
    "data-name": "Group 2722",
    transform: "translate(36.366 0.295)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2721",
    "data-name": "Group 2721"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2720",
    "data-name": "Group 2720",
    clipPath: "url(#clip-path-7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10689",
    "data-name": "Path 10689",
    d: "M26.733,20.383V.706a.487.487,0,0,1,.484-.49H38.443a.487.487,0,0,1,.484.49V2.821a.487.487,0,0,1-.484.49H31.037a.487.487,0,0,0-.484.488V8.36a.487.487,0,0,0,.484.49h6.275a.486.486,0,0,1,.484.488v2.117a.486.486,0,0,1-.484.488H31.037a.487.487,0,0,0-.484.49v4.856a.487.487,0,0,0,.484.488h7.8a.486.486,0,0,1,.483.49v2.115a.486.486,0,0,1-.483.49H27.217a.487.487,0,0,1-.484-.49",
    transform: "translate(-26.733 -0.217)",
    fill: "#040504"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2725",
    "data-name": "Group 2725",
    transform: "translate(51.572 0)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2724",
    "data-name": "Group 2724",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2723",
    "data-name": "Group 2723",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10690",
    "data-name": "Path 10690",
    d: "M48.743,15.528c0-3.8-9.994-3.123-9.994-9.635,0-3.33,3-5.893,7.212-5.893A9.056,9.056,0,0,1,51.7,1.839a.5.5,0,0,1,.065.7L50.045,4.569a.477.477,0,0,1-.676.057,5.463,5.463,0,0,0-3.712-1.415c-1.926,0-3,1.031-3,2.386,0,3.889,9.963,3.183,9.963,9.7,0,3.093-2.628,5.951-7.732,5.951a10.961,10.961,0,0,1-6.795-2.1A.5.5,0,0,1,38,18.464l1.627-2.245a.481.481,0,0,1,.7-.084,7.768,7.768,0,0,0,5.018,1.958c2.262,0,3.393-1.149,3.393-2.564",
    transform: "translate(-37.911 0)",
    fill: "#040504"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2728",
    "data-name": "Group 2728",
    transform: "translate(67.048 0.295)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2727",
    "data-name": "Group 2727"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2726",
    "data-name": "Group 2726",
    clipPath: "url(#clip-path-9)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10691",
    "data-name": "Path 10691",
    d: "M54.275,3.31h-4.5a.487.487,0,0,1-.484-.49V.705a.486.486,0,0,1,.484-.488H63.566a.486.486,0,0,1,.483.488V2.821a.486.486,0,0,1-.483.49H59.093a.486.486,0,0,0-.483.49V20.382a.487.487,0,0,1-.484.49H55.242a.486.486,0,0,1-.483-.49V3.8a.487.487,0,0,0-.484-.49",
    transform: "translate(-49.288 -0.216)",
    fill: "#040504"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2731",
    "data-name": "Group 2731",
    transform: "translate(83.245 0)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2730",
    "data-name": "Group 2730",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2729",
    "data-name": "Group 2729",
    clipPath: "url(#clip-path-10)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10692",
    "data-name": "Path 10692",
    d: "M69.691,21.244c-5.256,0-8.5-2.828-8.5-10.489C61.194,3.182,64.77,0,69.965,0c5.226,0,8.558,2.858,8.558,10.518,0,7.544-3.636,10.726-8.833,10.726m.245-3.123c2.842,0,4.614-1.8,4.614-7.4,0-5.658-1.864-7.6-4.828-7.6-2.751,0-4.616,1.738-4.616,7.366,0,5.686,1.865,7.631,4.829,7.631",
    transform: "translate(-61.195 0)",
    fill: "#040504"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2734",
    "data-name": "Group 2734",
    transform: "translate(104.82 0.295)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2733",
    "data-name": "Group 2733"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2732",
    "data-name": "Group 2732",
    clipPath: "url(#clip-path-11)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10693",
    "data-name": "Path 10693",
    d: "M80.479,4.784c.152,1.945.214,3.535.214,6.542v9.057a.487.487,0,0,1-.484.49H77.539a.487.487,0,0,1-.484-.49V.705a.487.487,0,0,1,.484-.488h4A.48.48,0,0,1,81.96.47l5.3,9.764c.977,1.8,2.015,3.831,2.81,5.688h.154c-.154-2.5-.154-5.009-.154-7.012V.705a.486.486,0,0,1,.483-.488H93.2a.486.486,0,0,1,.483.488V20.382a.486.486,0,0,1-.483.49H89.29a.479.479,0,0,1-.422-.253L83.319,10.471c-.978-1.827-1.832-3.684-2.688-5.688Z",
    transform: "translate(-77.056 -0.216)",
    fill: "#040504"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2737",
    "data-name": "Group 2737",
    transform: "translate(0 36.102)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2736",
    "data-name": "Group 2736"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2735",
    "data-name": "Group 2735",
    clipPath: "url(#clip-path-12)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10694",
    "data-name": "Path 10694",
    d: "M18.333,26.828a.286.286,0,0,0-.088-.2.263.263,0,0,0-.195-.094H15.51a.239.239,0,0,0-.186.094.306.306,0,0,0-.079.2v12.59a4.079,4.079,0,0,1,.018.424v.426a11.671,11.671,0,0,1-.212,2.186A5.331,5.331,0,0,1,14.2,44.5a4.757,4.757,0,0,1-1.8,1.522,6.9,6.9,0,0,1-3.07.612,7.721,7.721,0,0,1-2.445-.34,5.293,5.293,0,0,1-1.7-.91,4.384,4.384,0,0,1-1.094-1.336,7.383,7.383,0,0,1-.626-1.616,9.436,9.436,0,0,1-.283-1.752q-.061-.9-.061-1.736V35.42a.257.257,0,0,0-.1-.214.325.325,0,0,0-.2-.076H.317a.338.338,0,0,0-.229.076A.266.266,0,0,0,0,35.42v3.556A15.2,15.2,0,0,0,.5,42.93a9.881,9.881,0,0,0,1.57,3.334A8.191,8.191,0,0,0,4.817,48.63a9.364,9.364,0,0,0,4.04,1.028,13.912,13.912,0,0,0,3.3-.458,8.085,8.085,0,0,0,2.9-1.43,8.211,8.211,0,0,0,2.187-2.67,11.628,11.628,0,0,0,1.174-4.186h1.835V37.938H18.333Z",
    transform: "translate(0 -26.539)",
    fill: "#040504"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2740",
    "data-name": "Group 2740",
    transform: "translate(6.652 33.107)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2739",
    "data-name": "Group 2739"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2738",
    "data-name": "Group 2738",
    clipPath: "url(#clip-path-13)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10695",
    "data-name": "Path 10695",
    d: "M5.411,27.3a1.713,1.713,0,0,0,.565.374,1.74,1.74,0,0,0,.68.136,1.786,1.786,0,0,0,.7-.136,1.807,1.807,0,0,0,.573-.374,1.769,1.769,0,0,0,.389-.552,1.667,1.667,0,0,0,0-1.344,1.759,1.759,0,0,0-.389-.554,1.831,1.831,0,0,0-.573-.374,1.786,1.786,0,0,0-.7-.136,1.779,1.779,0,0,0-1.245.51,1.823,1.823,0,0,0-.38.554,1.667,1.667,0,0,0,0,1.344,1.834,1.834,0,0,0,.38.552",
    transform: "translate(-4.89 -24.338)",
    fill: "#040504"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2743",
    "data-name": "Group 2743",
    transform: "translate(20.645 47.5)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2742",
    "data-name": "Group 2742"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2741",
    "data-name": "Group 2741",
    clipPath: "url(#clip-path-14)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1112",
    "data-name": "Rectangle 1112",
    width: 6.917,
    height: 2.978,
    transform: "translate(-0.001 0)",
    fill: "#040504"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2746",
    "data-name": "Group 2746",
    transform: "translate(28.285 47.5)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2745",
    "data-name": "Group 2745"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2744",
    "data-name": "Group 2744",
    clipPath: "url(#clip-path-14)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1114",
    "data-name": "Rectangle 1114",
    width: 6.917,
    height: 2.978,
    transform: "translate(0 0)",
    fill: "#040504"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2749",
    "data-name": "Group 2749",
    transform: "translate(35.537 36.102)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2748",
    "data-name": "Group 2748"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2747",
    "data-name": "Group 2747",
    clipPath: "url(#clip-path-16)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10696",
    "data-name": "Path 10696",
    d: "M32.617,26.828a.286.286,0,0,0-.088-.2.3.3,0,0,0-.23-.094h-2.5a.263.263,0,0,0-.195.094.286.286,0,0,0-.088.2v11.11H26.124v2.976H36.181V37.938H32.617Z",
    transform: "translate(-26.124 -26.539)",
    fill: "#040504"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2752",
    "data-name": "Group 2752",
    transform: "translate(36.49 28.684)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2751",
    "data-name": "Group 2751"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2750",
    "data-name": "Group 2750",
    clipPath: "url(#clip-path-17)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10697",
    "data-name": "Path 10697",
    d: "M27.345,24.046a1.713,1.713,0,0,0,.565.374,1.74,1.74,0,0,0,.68.136,1.786,1.786,0,0,0,.7-.136,1.807,1.807,0,0,0,.573-.374,1.769,1.769,0,0,0,.389-.552,1.67,1.67,0,0,0,0-1.345,1.769,1.769,0,0,0-.389-.552,1.831,1.831,0,0,0-.573-.374,1.786,1.786,0,0,0-.7-.136,1.779,1.779,0,0,0-1.245.51,1.834,1.834,0,0,0-.38.552,1.67,1.67,0,0,0,0,1.345,1.834,1.834,0,0,0,.38.552",
    transform: "translate(-26.825 -21.086)",
    fill: "#040504"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2755",
    "data-name": "Group 2755",
    transform: "translate(41.36 28.684)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2754",
    "data-name": "Group 2754"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2753",
    "data-name": "Group 2753",
    clipPath: "url(#clip-path-17)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10698",
    "data-name": "Path 10698",
    d: "M30.925,24.046a1.713,1.713,0,0,0,.565.374,1.74,1.74,0,0,0,.68.136,1.786,1.786,0,0,0,.7-.136,1.807,1.807,0,0,0,.573-.374,1.769,1.769,0,0,0,.389-.552,1.67,1.67,0,0,0,0-1.345,1.769,1.769,0,0,0-.389-.552,1.831,1.831,0,0,0-.573-.374,1.786,1.786,0,0,0-.7-.136,1.779,1.779,0,0,0-1.245.51,1.834,1.834,0,0,0-.38.552,1.67,1.67,0,0,0,0,1.345,1.834,1.834,0,0,0,.38.552",
    transform: "translate(-30.405 -21.086)",
    fill: "#040504"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2758",
    "data-name": "Group 2758",
    transform: "translate(45.86 47.5)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2757",
    "data-name": "Group 2757"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2756",
    "data-name": "Group 2756",
    clipPath: "url(#clip-path-14)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1119",
    "data-name": "Rectangle 1119",
    width: 6.917,
    height: 2.978,
    transform: "translate(0 0)",
    fill: "#040504"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2761",
    "data-name": "Group 2761",
    transform: "translate(53.5 47.5)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2760",
    "data-name": "Group 2760"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2759",
    "data-name": "Group 2759",
    clipPath: "url(#clip-path-14)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1121",
    "data-name": "Rectangle 1121",
    width: 6.917,
    height: 2.978,
    transform: "translate(0 0)",
    fill: "#040504"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2764",
    "data-name": "Group 2764",
    transform: "translate(60.77 36.102)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2763",
    "data-name": "Group 2763"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2762",
    "data-name": "Group 2762",
    clipPath: "url(#clip-path-21)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10699",
    "data-name": "Path 10699",
    d: "M67.4,26.539H64.877a.313.313,0,0,0-.3.29V37.937H58.789V26.829a.286.286,0,0,0-.088-.2.3.3,0,0,0-.229-.094H55.966a.255.255,0,0,0-.2.094.306.306,0,0,0-.079.2V37.937H49.9V26.829a.313.313,0,0,0-.3-.29H47.055a.214.214,0,0,0-.177.094.325.325,0,0,0-.069.2V37.937H44.673v2.978H63.924a3.848,3.848,0,0,0,2.8-.952,4.2,4.2,0,0,0,.979-3.114V26.829a.273.273,0,0,0-.1-.2.289.289,0,0,0-.2-.094",
    transform: "translate(-44.673 -26.539)",
    fill: "#040504"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2767",
    "data-name": "Group 2767",
    transform: "translate(90.603 36.067)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2766",
    "data-name": "Group 2766"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2765",
    "data-name": "Group 2765",
    clipPath: "url(#clip-path-22)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10700",
    "data-name": "Path 10700",
    d: "M75.62,26.8a.253.253,0,0,0-.283-.29H72.8q-.265,0-.265.29v15.72a5.289,5.289,0,0,1-.688,1.872,4.02,4.02,0,0,1-1.129,1.19,4.759,4.759,0,0,1-1.447.656,8.292,8.292,0,0,1-1.658.263H66.9a.279.279,0,0,0-.211.094.3.3,0,0,0-.088.214v2.415a.2.2,0,0,0,.114.2,1.158,1.158,0,0,0,.256.094,1.176,1.176,0,0,0,.283.034h.211a4.619,4.619,0,0,0,.494-.026c.166-.016.336-.037.513-.059a8.376,8.376,0,0,0,2.681-.9,7.572,7.572,0,0,0,2.136-1.736A9.076,9.076,0,0,0,74.8,44.275a13.427,13.427,0,0,0,.82-3.352h1.729V37.947H75.567Z",
    transform: "translate(-66.604 -26.514)",
    fill: "#040504"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2770",
    "data-name": "Group 2770",
    transform: "translate(101.49 47.5)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2769",
    "data-name": "Group 2769"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2768",
    "data-name": "Group 2768",
    clipPath: "url(#clip-path-14)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1125",
    "data-name": "Rectangle 1125",
    width: 6.917,
    height: 2.978,
    transform: "translate(0 0)",
    fill: "#040504"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2773",
    "data-name": "Group 2773",
    transform: "translate(109.13 47.5)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2772",
    "data-name": "Group 2772"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2771",
    "data-name": "Group 2771",
    clipPath: "url(#clip-path-14)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1127",
    "data-name": "Rectangle 1127",
    width: 6.917,
    height: 2.978,
    transform: "translate(-0.001 0)",
    fill: "#040504"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2776",
    "data-name": "Group 2776",
    transform: "translate(116.841 54.356)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2775",
    "data-name": "Group 2775"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2774",
    "data-name": "Group 2774",
    clipPath: "url(#clip-path-17)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10701",
    "data-name": "Path 10701",
    d: "M88.927,40.468a1.813,1.813,0,0,0-.574-.374,1.781,1.781,0,0,0-.7-.136,1.738,1.738,0,0,0-.679.136,1.7,1.7,0,0,0-.565.374,1.834,1.834,0,0,0-.38.552,1.67,1.67,0,0,0,0,1.345,1.834,1.834,0,0,0,.38.552,1.72,1.72,0,0,0,.565.374,1.738,1.738,0,0,0,.679.136,1.781,1.781,0,0,0,.7-.136,1.837,1.837,0,0,0,.574-.374,1.765,1.765,0,0,0,.388-.552,1.67,1.67,0,0,0,0-1.345,1.765,1.765,0,0,0-.388-.552",
    transform: "translate(-85.892 -39.958)",
    fill: "#040504"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2779",
    "data-name": "Group 2779",
    transform: "translate(116.241 36.102)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2778",
    "data-name": "Group 2778"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2777",
    "data-name": "Group 2777",
    clipPath: "url(#clip-path-26)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10702",
    "data-name": "Path 10702",
    d: "M90.577,26.633a.255.255,0,0,0-.2-.094H87.833a.253.253,0,0,0-.2.094.3.3,0,0,0-.08.2V37.937h-2.1v2.978H86.9a3.817,3.817,0,0,0,2.789-.952,4.233,4.233,0,0,0,.97-3.114V26.829a.3.3,0,0,0-.079-.2",
    transform: "translate(-85.451 -26.539)",
    fill: "#040504"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3428",
    "data-name": "Group 3428"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3429",
    "data-name": "Group 3429",
    transform: "translate(130.566)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3428-2",
    "data-name": "Group 3428",
    clipPath: "url(#clip-path-27)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1431",
    "data-name": "Rectangle 1431",
    width: 60.935,
    height: 62.428,
    transform: "matrix(0.617, -0.787, 0.787, 0.617, -19.277, 24.505)",
    fill: "url(#linear-gradient)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3431",
    "data-name": "Group 3431",
    transform: "translate(130.566 33.24)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3430",
    "data-name": "Group 3430",
    clipPath: "url(#clip-path-28)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1432",
    "data-name": "Rectangle 1432",
    width: 30.825,
    height: 29.234,
    transform: "translate(-12.749 16.148) rotate(-51.931)",
    fill: "url(#linear-gradient-2)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3433",
    "data-name": "Group 3433",
    transform: "translate(0 0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3432",
    "data-name": "Group 3432",
    clipPath: "url(#clip-path-29)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11063",
    "data-name": "Path 11063",
    d: "M14.117,8.82c-.848,2.628-3.2,4.395-7.628,4.395H4.622a.486.486,0,0,0-.484.489v6.675a.487.487,0,0,1-.484.489H.806a.487.487,0,0,1-.484-.489V.722A.487.487,0,0,1,.806.233H7.762A6.642,6.642,0,0,1,14.117,8.82M4.138,3.872V9.664a.486.486,0,0,0,.484.489H6.337c3.266,0,4.182-1.383,4.182-3.384,0-2.384-1.281-3.386-4-3.386h-1.9a.487.487,0,0,0-.484.489",
    transform: "translate(0.084 0.06)",
    fill: "#003a56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11064",
    "data-name": "Path 11064",
    d: "M20.821.234c4.64,0,7.328,1.706,7.328,5.975,0,3.5-2.107,5.3-4.64,5.681v.117c1.037.471,1.74,1.207,2.747,2.885l3.078,5.236a.489.489,0,0,1-.415.738H25.5a.482.482,0,0,1-.423-.252l-3.525-6.43a2.525,2.525,0,0,0-2.473-1.324h-.34a.486.486,0,0,0-.484.488v7.029a.487.487,0,0,1-.484.489H14.955a.487.487,0,0,1-.484-.489V.722a.486.486,0,0,1,.484-.488ZM18.257,9.37a.487.487,0,0,0,.484.489h1.653c2.656,0,3.877-1.06,3.877-3.326s-1.4-3.208-3.907-3.208H18.741a.486.486,0,0,0-.484.488Z",
    transform: "translate(3.762 0.06)",
    fill: "#003a56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11065",
    "data-name": "Path 11065",
    d: "M29.154,20.378V.722a.487.487,0,0,1,.484-.489H40.851a.487.487,0,0,1,.484.489V2.835a.486.486,0,0,1-.484.489h-7.4a.486.486,0,0,0-.483.489V8.369a.486.486,0,0,0,.483.489h6.27a.487.487,0,0,1,.484.489v2.113a.487.487,0,0,1-.484.489h-6.27a.486.486,0,0,0-.483.489v4.851a.486.486,0,0,0,.483.489h7.8a.486.486,0,0,1,.483.489v2.113a.486.486,0,0,1-.483.489H29.638a.487.487,0,0,1-.484-.489",
    transform: "translate(7.579 0.06)",
    fill: "#003a56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11066",
    "data-name": "Path 11066",
    d: "M52.031,15.511c0-3.8-9.983-3.12-9.983-9.625C42.048,2.56,45.039,0,49.252,0a9.051,9.051,0,0,1,5.735,1.837.494.494,0,0,1,.064.7L53.331,4.564a.476.476,0,0,1-.675.058,5.456,5.456,0,0,0-3.708-1.414c-1.924,0-2.992,1.029-2.992,2.384,0,3.886,9.952,3.179,9.952,9.684,0,3.091-2.626,5.946-7.724,5.946a10.959,10.959,0,0,1-6.787-2.1.494.494,0,0,1-.093-.675L42.929,16.2a.481.481,0,0,1,.7-.084,7.753,7.753,0,0,0,5.012,1.955c2.26,0,3.389-1.149,3.389-2.561",
    transform: "translate(10.713 -0.001)",
    fill: "#003a56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11067",
    "data-name": "Path 11067",
    d: "M58.462,3.325h-4.5a.487.487,0,0,1-.484-.489V.723a.487.487,0,0,1,.484-.489H67.743a.487.487,0,0,1,.484.489V2.836a.487.487,0,0,1-.484.489H63.275a.486.486,0,0,0-.483.489V20.379a.487.487,0,0,1-.484.489h-2.88a.486.486,0,0,1-.483-.489V3.814a.487.487,0,0,0-.484-.489",
    transform: "translate(13.903 0.06)",
    fill: "#003a56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11068",
    "data-name": "Path 11068",
    d: "M74.809,21.221c-5.252,0-8.487-2.825-8.487-10.479C66.322,3.179,69.894,0,75.084,0c5.221,0,8.549,2.855,8.549,10.508,0,7.535-3.634,10.713-8.823,10.713m.244-3.12c2.839,0,4.61-1.8,4.61-7.388,0-5.651-1.862-7.594-4.824-7.594-2.747,0-4.61,1.736-4.61,7.358,0,5.681,1.863,7.624,4.824,7.624",
    transform: "translate(17.241 -0.001)",
    fill: "#003a56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11069",
    "data-name": "Path 11069",
    d: "M86.847,4.8c.152,1.943.214,3.532.214,6.534v9.049a.487.487,0,0,1-.484.489H83.911a.487.487,0,0,1-.484-.489V.723a.487.487,0,0,1,.484-.489H87.9a.485.485,0,0,1,.425.253l5.3,9.755c.978,1.8,2.016,3.826,2.81,5.681h.152c-.152-2.5-.152-5-.152-7.005V.723a.486.486,0,0,1,.483-.489h2.636a.487.487,0,0,1,.484.489V20.379a.487.487,0,0,1-.484.489h-3.9a.483.483,0,0,1-.423-.253l-5.54-10.138C88.709,8.652,87.854,6.8,87,4.8Z",
    transform: "translate(21.687 0.06)",
    fill: "#003a56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11070",
    "data-name": "Path 11070",
    d: "M18.635,28.912a.28.28,0,0,0-.088-.2.266.266,0,0,0-.194-.093H15.816a.239.239,0,0,0-.185.093.3.3,0,0,0-.079.2V41.487c.011.113.018.256.018.426v.425a11.677,11.677,0,0,1-.212,2.184,5.337,5.337,0,0,1-.847,2.04,4.723,4.723,0,0,1-1.8,1.521,6.909,6.909,0,0,1-3.067.611,7.751,7.751,0,0,1-2.441-.339,5.248,5.248,0,0,1-1.7-.91A4.389,4.389,0,0,1,4.411,46.11,7.363,7.363,0,0,1,3.786,44.5,9.458,9.458,0,0,1,3.5,42.745q-.062-.9-.062-1.732V37.494a.257.257,0,0,0-.1-.213.319.319,0,0,0-.2-.077H.64a.332.332,0,0,0-.229.077.265.265,0,0,0-.088.213v3.552A15.275,15.275,0,0,0,.823,45a9.87,9.87,0,0,0,1.57,3.33,8.184,8.184,0,0,0,2.74,2.362,9.364,9.364,0,0,0,4.036,1.028,13.913,13.913,0,0,0,3.3-.459,8.065,8.065,0,0,0,2.9-1.428,8.2,8.2,0,0,0,2.186-2.669,11.62,11.62,0,0,0,1.172-4.181h1.833V40.009H18.635Z",
    transform: "translate(0.084 7.44)",
    fill: "#003a56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11071",
    "data-name": "Path 11071",
    d: "M18.635,28.912a.28.28,0,0,0-.088-.2.266.266,0,0,0-.194-.093H15.816a.239.239,0,0,0-.185.093.3.3,0,0,0-.079.2V41.487c.011.113.018.256.018.426v.425a11.677,11.677,0,0,1-.212,2.184,5.337,5.337,0,0,1-.847,2.04,4.723,4.723,0,0,1-1.8,1.521,6.909,6.909,0,0,1-3.067.611,7.751,7.751,0,0,1-2.441-.339,5.248,5.248,0,0,1-1.7-.91A4.389,4.389,0,0,1,4.411,46.11,7.363,7.363,0,0,1,3.786,44.5,9.458,9.458,0,0,1,3.5,42.745q-.062-.9-.062-1.732V37.494a.257.257,0,0,0-.1-.213.319.319,0,0,0-.2-.077H.64a.332.332,0,0,0-.229.077.265.265,0,0,0-.088.213v3.552A15.275,15.275,0,0,0,.823,45a9.87,9.87,0,0,0,1.57,3.33,8.184,8.184,0,0,0,2.74,2.362,9.364,9.364,0,0,0,4.036,1.028,13.913,13.913,0,0,0,3.3-.459,8.065,8.065,0,0,0,2.9-1.428,8.2,8.2,0,0,0,2.186-2.669,11.62,11.62,0,0,0,1.172-4.181h1.833V40.009H18.635Z",
    transform: "translate(0.084 7.44)",
    fill: "none",
    stroke: "#003a56",
    strokeMiterlimit: 10,
    strokeWidth: 0.644
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11072",
    "data-name": "Path 11072",
    d: "M6.116,29.206a1.778,1.778,0,0,0,1.242.51,1.794,1.794,0,0,0,.7-.136,1.849,1.849,0,0,0,.573-.374,1.762,1.762,0,0,0,.387-.552,1.669,1.669,0,0,0,0-1.343,1.762,1.762,0,0,0-.387-.552,1.849,1.849,0,0,0-.573-.374,1.794,1.794,0,0,0-.7-.136,1.778,1.778,0,0,0-1.242.51,1.849,1.849,0,0,0-.379.552,1.669,1.669,0,0,0,0,1.343,1.849,1.849,0,0,0,.379.552",
    transform: "translate(1.455 6.823)",
    fill: "#003a56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11073",
    "data-name": "Path 11073",
    d: "M6.116,29.206a1.778,1.778,0,0,0,1.242.51,1.794,1.794,0,0,0,.7-.136,1.849,1.849,0,0,0,.573-.374,1.762,1.762,0,0,0,.387-.552,1.669,1.669,0,0,0,0-1.343,1.762,1.762,0,0,0-.387-.552,1.849,1.849,0,0,0-.573-.374,1.794,1.794,0,0,0-.7-.136,1.778,1.778,0,0,0-1.242.51,1.849,1.849,0,0,0-.379.552,1.669,1.669,0,0,0,0,1.343A1.849,1.849,0,0,0,6.116,29.206Z",
    transform: "translate(1.455 6.823)",
    fill: "none",
    stroke: "#003a56",
    strokeMiterlimit: 10,
    strokeWidth: 0.644
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1433",
    "data-name": "Rectangle 1433",
    width: 6.91,
    height: 2.975,
    transform: "translate(21.029 47.449)",
    fill: "#003a56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1434",
    "data-name": "Rectangle 1434",
    width: 6.91,
    height: 2.975,
    transform: "translate(21.029 47.449)",
    fill: "none",
    stroke: "#003a56",
    strokeMiterlimit: 10,
    strokeWidth: 0.644
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1435",
    "data-name": "Rectangle 1435",
    width: 6.91,
    height: 2.975,
    transform: "translate(28.662 47.449)",
    fill: "#003a56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1436",
    "data-name": "Rectangle 1436",
    width: 6.91,
    height: 2.975,
    transform: "translate(28.662 47.449)",
    fill: "none",
    stroke: "#003a56",
    strokeMiterlimit: 10,
    strokeWidth: 0.644
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11074",
    "data-name": "Path 11074",
    d: "M34.984,28.912a.28.28,0,0,0-.088-.2.3.3,0,0,0-.229-.093h-2.5a.264.264,0,0,0-.194.093.28.28,0,0,0-.088.2v11.1H28.5v2.973H38.545V40.009H34.984Z",
    transform: "translate(7.408 7.44)",
    fill: "#003a56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11075",
    "data-name": "Path 11075",
    d: "M34.984,28.912a.28.28,0,0,0-.088-.2.3.3,0,0,0-.229-.093h-2.5a.264.264,0,0,0-.194.093.28.28,0,0,0-.088.2v11.1H28.5v2.973H38.545V40.009H34.984Z",
    transform: "translate(7.408 7.44)",
    fill: "none",
    stroke: "#003a56",
    strokeMiterlimit: 10,
    strokeWidth: 0.644
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11076",
    "data-name": "Path 11076",
    d: "M29.772,25.7a1.778,1.778,0,0,0,1.242.51,1.794,1.794,0,0,0,.7-.136,1.849,1.849,0,0,0,.573-.374,1.762,1.762,0,0,0,.387-.552,1.669,1.669,0,0,0,0-1.343,1.762,1.762,0,0,0-.387-.552,1.849,1.849,0,0,0-.573-.374,1.793,1.793,0,0,0-.7-.136,1.778,1.778,0,0,0-1.242.51,1.849,1.849,0,0,0-.379.552,1.668,1.668,0,0,0,0,1.343,1.849,1.849,0,0,0,.379.552",
    transform: "translate(7.604 5.911)",
    fill: "#003a56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11077",
    "data-name": "Path 11077",
    d: "M29.772,25.7a1.778,1.778,0,0,0,1.242.51,1.794,1.794,0,0,0,.7-.136,1.849,1.849,0,0,0,.573-.374,1.762,1.762,0,0,0,.387-.552,1.669,1.669,0,0,0,0-1.343,1.762,1.762,0,0,0-.387-.552,1.849,1.849,0,0,0-.573-.374,1.793,1.793,0,0,0-.7-.136,1.778,1.778,0,0,0-1.242.51,1.849,1.849,0,0,0-.379.552,1.668,1.668,0,0,0,0,1.343A1.849,1.849,0,0,0,29.772,25.7Z",
    transform: "translate(7.604 5.911)",
    fill: "none",
    stroke: "#003a56",
    strokeMiterlimit: 10,
    strokeWidth: 0.644
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11078",
    "data-name": "Path 11078",
    d: "M33.634,25.7a1.778,1.778,0,0,0,1.242.51,1.794,1.794,0,0,0,.7-.136,1.849,1.849,0,0,0,.573-.374,1.762,1.762,0,0,0,.387-.552,1.669,1.669,0,0,0,0-1.343,1.762,1.762,0,0,0-.387-.552,1.849,1.849,0,0,0-.573-.374,1.793,1.793,0,0,0-.7-.136,1.778,1.778,0,0,0-1.242.51,1.849,1.849,0,0,0-.379.552,1.668,1.668,0,0,0,0,1.343,1.849,1.849,0,0,0,.379.552",
    transform: "translate(8.608 5.911)",
    fill: "#003a56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11079",
    "data-name": "Path 11079",
    d: "M33.634,25.7a1.778,1.778,0,0,0,1.242.51,1.794,1.794,0,0,0,.7-.136,1.849,1.849,0,0,0,.573-.374,1.762,1.762,0,0,0,.387-.552,1.669,1.669,0,0,0,0-1.343,1.762,1.762,0,0,0-.387-.552,1.849,1.849,0,0,0-.573-.374,1.793,1.793,0,0,0-.7-.136,1.778,1.778,0,0,0-1.242.51,1.849,1.849,0,0,0-.379.552,1.668,1.668,0,0,0,0,1.343A1.849,1.849,0,0,0,33.634,25.7Z",
    transform: "translate(8.608 5.911)",
    fill: "none",
    stroke: "#003a56",
    strokeMiterlimit: 10,
    strokeWidth: 0.644
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1437",
    "data-name": "Rectangle 1437",
    width: 6.91,
    height: 2.975,
    transform: "translate(46.216 47.449)",
    fill: "#003a56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1438",
    "data-name": "Rectangle 1438",
    width: 6.91,
    height: 2.975,
    transform: "translate(46.216 47.449)",
    fill: "none",
    stroke: "#003a56",
    strokeMiterlimit: 10,
    strokeWidth: 0.644
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1439",
    "data-name": "Rectangle 1439",
    width: 6.91,
    height: 2.975,
    transform: "translate(53.849 47.449)",
    fill: "#003a56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1440",
    "data-name": "Rectangle 1440",
    width: 6.91,
    height: 2.975,
    transform: "translate(53.849 47.449)",
    fill: "none",
    stroke: "#003a56",
    strokeMiterlimit: 10,
    strokeWidth: 0.644
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11080",
    "data-name": "Path 11080",
    d: "M71.205,28.623h-2.52a.311.311,0,0,0-.3.289v11.1H62.6v-11.1a.282.282,0,0,0-.088-.2.3.3,0,0,0-.229-.093h-2.5a.255.255,0,0,0-.2.093.3.3,0,0,0-.079.2v11.1H53.719v-11.1a.311.311,0,0,0-.3-.289H50.882a.214.214,0,0,0-.176.093.324.324,0,0,0-.071.2v11.1H48.5v2.975H67.733a3.84,3.84,0,0,0,2.793-.953,4.2,4.2,0,0,0,.979-3.11V28.912a.275.275,0,0,0-.1-.2.3.3,0,0,0-.2-.093",
    transform: "translate(12.608 7.44)",
    fill: "#003a56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11081",
    "data-name": "Path 11081",
    d: "M71.205,28.623h-2.52a.311.311,0,0,0-.3.289v11.1H62.6v-11.1a.282.282,0,0,0-.088-.2.3.3,0,0,0-.229-.093h-2.5a.255.255,0,0,0-.2.093.3.3,0,0,0-.079.2v11.1H53.719v-11.1a.311.311,0,0,0-.3-.289H50.882a.214.214,0,0,0-.176.093.324.324,0,0,0-.071.2v11.1H48.5v2.975H67.733a3.84,3.84,0,0,0,2.793-.953,4.2,4.2,0,0,0,.979-3.11V28.912a.275.275,0,0,0-.1-.2A.3.3,0,0,0,71.205,28.623Z",
    transform: "translate(12.608 7.44)",
    fill: "none",
    stroke: "#003a56",
    strokeMiterlimit: 10,
    strokeWidth: 0.644
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11082",
    "data-name": "Path 11082",
    d: "M81.162,28.885a.252.252,0,0,0-.282-.289H78.343c-.176,0-.265.1-.265.289v15.7a5.282,5.282,0,0,1-.688,1.87,4.025,4.025,0,0,1-1.128,1.189,4.751,4.751,0,0,1-1.445.655,8.316,8.316,0,0,1-1.657.263h-.706a.279.279,0,0,0-.212.093.3.3,0,0,0-.088.212v2.414a.205.205,0,0,0,.115.2,1.156,1.156,0,0,0,.256.093,1.2,1.2,0,0,0,.282.034h.212c.164,0,.329-.009.493-.025s.335-.038.512-.059a8.423,8.423,0,0,0,2.68-.9,7.559,7.559,0,0,0,2.132-1.734,9.021,9.021,0,0,0,1.507-2.55,13.35,13.35,0,0,0,.82-3.348H82.89V40.016H81.11Z",
    transform: "translate(18.757 7.433)",
    fill: "#003a56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11083",
    "data-name": "Path 11083",
    d: "M81.162,28.885a.252.252,0,0,0-.282-.289H78.343c-.176,0-.265.1-.265.289v15.7a5.282,5.282,0,0,1-.688,1.87,4.025,4.025,0,0,1-1.128,1.189,4.751,4.751,0,0,1-1.445.655,8.316,8.316,0,0,1-1.657.263h-.706a.279.279,0,0,0-.212.093.3.3,0,0,0-.088.212v2.414a.205.205,0,0,0,.115.2,1.156,1.156,0,0,0,.256.093,1.2,1.2,0,0,0,.282.034h.212c.164,0,.329-.009.493-.025s.335-.038.512-.059a8.423,8.423,0,0,0,2.68-.9,7.559,7.559,0,0,0,2.132-1.734,9.021,9.021,0,0,0,1.507-2.55,13.35,13.35,0,0,0,.82-3.348H82.89V40.016H81.11Z",
    transform: "translate(18.757 7.433)",
    fill: "none",
    stroke: "#003a56",
    strokeMiterlimit: 10,
    strokeWidth: 0.644
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1441",
    "data-name": "Rectangle 1441",
    width: 6.91,
    height: 2.975,
    transform: "translate(101.788 47.449)",
    fill: "#003a56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1442",
    "data-name": "Rectangle 1442",
    width: 6.91,
    height: 2.975,
    transform: "translate(101.788 47.449)",
    fill: "none",
    stroke: "#003a56",
    strokeMiterlimit: 10,
    strokeWidth: 0.644
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1443",
    "data-name": "Rectangle 1443",
    width: 6.91,
    height: 2.975,
    transform: "translate(109.421 47.449)",
    fill: "#003a56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1444",
    "data-name": "Rectangle 1444",
    width: 6.91,
    height: 2.975,
    transform: "translate(109.421 47.449)",
    fill: "none",
    stroke: "#003a56",
    strokeMiterlimit: 10,
    strokeWidth: 0.644
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11084",
    "data-name": "Path 11084",
    d: "M95.989,43.605a1.835,1.835,0,0,0-.573-.374,1.783,1.783,0,0,0-.7-.136,1.748,1.748,0,0,0-.679.136,1.726,1.726,0,0,0-.564.374,1.845,1.845,0,0,0-.378.552,1.668,1.668,0,0,0,0,1.343,1.845,1.845,0,0,0,.378.552,1.726,1.726,0,0,0,.564.374,1.748,1.748,0,0,0,.679.136,1.783,1.783,0,0,0,.7-.136,1.835,1.835,0,0,0,.573-.374,1.787,1.787,0,0,0,.388-.552,1.669,1.669,0,0,0,0-1.343,1.787,1.787,0,0,0-.388-.552",
    transform: "translate(24.165 11.202)",
    fill: "#003a56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11085",
    "data-name": "Path 11085",
    d: "M95.989,43.605a1.835,1.835,0,0,0-.573-.374,1.783,1.783,0,0,0-.7-.136,1.748,1.748,0,0,0-.679.136,1.726,1.726,0,0,0-.564.374,1.845,1.845,0,0,0-.378.552,1.668,1.668,0,0,0,0,1.343,1.845,1.845,0,0,0,.378.552,1.726,1.726,0,0,0,.564.374,1.748,1.748,0,0,0,.679.136,1.783,1.783,0,0,0,.7-.136,1.835,1.835,0,0,0,.573-.374,1.787,1.787,0,0,0,.388-.552,1.669,1.669,0,0,0,0-1.343A1.787,1.787,0,0,0,95.989,43.605Z",
    transform: "translate(24.165 11.202)",
    fill: "none",
    stroke: "#003a56",
    strokeMiterlimit: 10,
    strokeWidth: 0.644
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11086",
    "data-name": "Path 11086",
    d: "M97.6,28.716a.256.256,0,0,0-.2-.093H94.862a.255.255,0,0,0-.2.093.3.3,0,0,0-.079.2v11.1h-2.1v2.975h1.445a3.806,3.806,0,0,0,2.785-.953,4.222,4.222,0,0,0,.97-3.11V28.912a.3.3,0,0,0-.079-.2",
    transform: "translate(24.041 7.44)",
    fill: "#003a56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11087",
    "data-name": "Path 11087",
    d: "M97.6,28.716a.256.256,0,0,0-.2-.093H94.862a.255.255,0,0,0-.2.093.3.3,0,0,0-.079.2v11.1h-2.1v2.975h1.445a3.806,3.806,0,0,0,2.785-.953,4.222,4.222,0,0,0,.97-3.11V28.912A.3.3,0,0,0,97.6,28.716Z",
    transform: "translate(24.041 7.44)",
    fill: "none",
    stroke: "#003a56",
    strokeMiterlimit: 10,
    strokeWidth: 0.644
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWrk10);
export default __webpack_public_path__ + "static/media/wrk-10.91cbf4b396a7e080b8b5e91ac2dcc73f.svg";
export { ForwardRef as ReactComponent };